
import { IPaginationInfoResult } from "./IPaginationInfoResult";


export class PaginationInfoResult implements IPaginationInfoResult
{
    itemsCount: number = 0;
    totalPages: number = 0;
    pageSize: number = 0;
    pageNumber: number = 0;
}
